import styled from "styled-components";

export const Container = styled.div`
  padding: 30px 130px;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  @media(max-width: 947px) {
    padding: 32px 50px;
  }
`;

export const Title = styled.h1`
  margin-bottom: 26px;

  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  color: #0E1E64;
  font-family: "Platform Web";
`;

export const Content = styled.div`
  display: flex;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContainerPlan = styled.div`
  flex: 2;
`;

export const MainImage = styled.div`
  position: relative;
  flex: 1;

  div {
    position: absolute;
    width: 342px;
    height: 350px;
    background: #6A522F;
    border-radius: 11px;
  }

  img {
    position: absolute;
    top: -100px;
    left: -100px;
  }

  @media(max-width: 1281px) {
    display: none;
  }
`

export const Plans = styled.div`
  display: flex;
`;
